import React from 'react';

// MUI
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';

const EnhancedTableHead = (props) => {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="select-all-products">
      <TableRow>
        <TableCell className="select-all-checkbox" padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            style={{ color: '#F4F9E9' }}
          />
        </TableCell>
        <TableCell className="table-head">More Details</TableCell>
        {headCells.map((headCell) => {
          return (
            <TableCell
              className="table-head"
              key={headCell.id}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
              // Only action columns claim a width: their controls can't reflow, so
              // the column needs a floor. Data columns keep sizing to content.
              style={headCell.action ? { minWidth: headCell.minWidth } : undefined}
            >
              {/* action columns hold controls, not data — nothing to sort by */}
              {headCell.action ? (
                headCell.label
              ) : (
                <TableSortLabel
                  // className="table-head"
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span>{order === 'desc' ? '' : ''}</span>
                  ) : null}
                </TableSortLabel>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
